import { provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, DOCUMENT, Provider } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withRouterConfig } from '@angular/router';
import { provideHotToastConfig } from '@ngxpert/hot-toast';
import { MARKED_OPTIONS, MarkedRenderer, provideMarkdown } from 'ngx-markdown';

import { environment } from '~app-environment';
import { provideChatConfiguration } from '~ng-common-lib/chats/tokens/configuration';
import { COMMON_CLIENT_CONFIG } from '~ng-common-lib/core/tokens/client-config';

import { BUILD_TIME, CLIENT_CONFIG, CLIENT_ENVIRONMENT, ReachVersion } from '~/core/tokens';
import { rootRoutes } from '~/root/root.router';

import { provideMicrosoftAuthentication } from './modules/microsoft.module';
import { provideRootTransloco } from './modules/transloco.module';
import { CLIENT_CONFIG_GENERATED } from '../../environments/client-config.generated';

const provideClientTheme = (): Provider => {
	return {
		provide: APP_INITIALIZER,
		useFactory: (document: Document) => {
			return () => {
				const rootElement = document.documentElement;
				rootElement.setAttribute('client-theme', 'light');
			};
		},
		multi: true,
		deps: [DOCUMENT],
	};
};

declare const PACKAGE_VERSION: ReachVersion;

export const getRootProviders = () => {
	return [
		provideRouter(rootRoutes, withRouterConfig({ paramsInheritanceStrategy: 'always' })),
		provideClientTheme(),
		provideAnimations(),
		provideHttpClient(),
		{ provide: CLIENT_ENVIRONMENT, useValue: environment },
		{ provide: CLIENT_CONFIG, useValue: CLIENT_CONFIG_GENERATED },
		{ provide: COMMON_CLIENT_CONFIG, useValue: CLIENT_CONFIG_GENERATED },
		provideMarkdown({
			markedOptions: {
				provide: MARKED_OPTIONS,
				useFactory: () => {
					const renderer = new MarkedRenderer();
					renderer.link = (config) => {
						return `<a href="${config.href}" target="_blank">${config.text}</a>`;
					};
					return {
						renderer,
					};
				},
			},
		}),
		provideMicrosoftAuthentication(PACKAGE_VERSION),
		provideRootTransloco(),
		provideHotToastConfig(),
		{ provide: BUILD_TIME, useValue: BUILD_TIME },
		provideChatConfiguration({
			showOptions: false,
			canInteract: false,
		}),
	];
};
